import React, { useEffect } from "react";

// components
import Card from "../../../Card/Card";

// styles
import styles from "./Repejo.module.scss";

const Repejo = ({ title, text, shortcode, base_url, thank_you_url }) => {
  useEffect(() => {
    const handleRepejoCompleted = (event) => {
      // event details from Repejo
      // {
      //   checkout_short_code: string,
      //   type: "recurring" | "onetime",
      //   payer: {
      //     name: string | null,
      //     phone_number: string | null,
      //     email: string | null,
      //   },
      // };
      const detail = event.detail;
      console.log(detail.type, detail.payer);

      if (thank_you_url) {
        window.location.href = thank_you_url;
      }
    };

    document.addEventListener("repejo:completed", handleRepejoCompleted);

    return () => {
      document.removeEventListener("repejo:completed", handleRepejoCompleted);
    };
  }, [thank_you_url]);

  return (
    <div className={styles["repejo-container"]}>
      <Card title={title} text={text} className={"repejo-card"}>
        <div className={styles["inline-frame-container"]}>
          <repejo-checkout
            short_code={shortcode}
            host={base_url}
          ></repejo-checkout>
        </div>
      </Card>
    </div>
  );
};

export default Repejo;
